export default "__VITE_ASSET__D3YwZmac__"